import { EventsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/events/EventsServiceClientPb';
import {
  EventAttribute,
  CreateEventRequest,
  UpdateEventRequest,
  DeleteEventRequest,
  GetEventRequest,
  GetAttributeValuesRequest,
  GetTriggeredCountRequest,
  GetTotalStatisticsRequest,
  GetDetailedStatisticsRequest,
  ListEventsRequest,
  TimeInterval,
} from '@pushwoosh/rpc-service-client/pushwoosh/events/events_pb';

export type EventsExportClasses = {
  EventsServiceClient: typeof EventsServiceClient;
  EventAttribute: typeof EventAttribute;
  CreateEventRequest: typeof CreateEventRequest;
  UpdateEventRequest: typeof UpdateEventRequest;
  DeleteEventRequest: typeof DeleteEventRequest;
  GetEventRequest: typeof GetEventRequest;
  GetAttributeValuesRequest: typeof GetAttributeValuesRequest;
  GetTriggeredCountRequest: typeof GetTriggeredCountRequest;
  GetTotalStatisticsRequest: typeof GetTotalStatisticsRequest;
  GetDetailedStatisticsRequest: typeof GetDetailedStatisticsRequest;
  ListEventsRequest: typeof ListEventsRequest;
  TimeInterval: typeof TimeInterval;
};

export const events: EventsExportClasses = {
  EventsServiceClient,
  EventAttribute,
  CreateEventRequest,
  UpdateEventRequest,
  DeleteEventRequest,
  GetEventRequest,
  GetAttributeValuesRequest,
  GetTriggeredCountRequest,
  GetTotalStatisticsRequest,
  GetDetailedStatisticsRequest,
  ListEventsRequest,
  TimeInterval,
};
